import { ExAxios } from '@ExAxios';
import g from '@global';
import axios from 'axios';

/**
 * 获取机构列表
 * @param params{}
 * */
export const fetchOrganList = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/manage/organ/organ/findList`,
            {
                ...params,
            },
            {
                ...config,
            },
        ),
    );
/**
* 获取机构列表
* @param params{}
* */
export const fetchOrganTree = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/sys/subsys/sysSubSystem/org/findList`,
            {
                ...params,
            },
            {
                ...config,
            },
        ),
    );

/**
* 获取监测点列表
* @param params{}
* */
export const fetchMonitorList = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/disc/atmos/findList`,
            {
                params,
                ...config,
            },
        ),
    );
